<template>
  <div class="ProjectTree">
    <el-tree
      lazy
      highlight-current
      default-expand-all
      :expand-on-click-node="false"
      :indent="5"
      :data="projectList"
      :props="treeProps"
      :load="loadTree"
      @node-click="onTreeNodeClick">
      <span class="custom-tree-node"
        style="width:85%;"
        slot-scope="{ node, data }">
        <span class="project-tree-item">{{node.label}}</span>
        <ProjectTicketCount style="float:right;" :projectId="data.id"/>
      </span>
    </el-tree>

    <el-button
      style="width:100%;margin-top:20px;"
      @click="goProjectTable">管理项目</el-button>
  </div>
</template>

<script>
export default {
    name: 'ProjectTree',

    data() {
        return {
          treeProps: {
            label: 'name'
          },

          projectList: []
        }
    },

    methods: {
      goProjectTable() {
        this.$router.push('/ticket-vue/setting/Project');
      },

      onTreeNodeClick(data) {
        this.$emit('tree-node-click', data);
      },

      loadTree(node, resolve) {
        sdk.ProjectApi().listByParentId({
          parentId: node.data.id
        }).then(res => {
          resolve(res || []);
        })
      },

      listTop() {
        var _this = this;

        sdk.ProjectApi().listTop().then(res => {
            _this.projectList = res || [];
        });
      }
    },

    mounted() {
        this.listTop();
    }
}
</script>

<style>
  .ProjectTree .custom-tree-node {
    font-size: 16px;
  }

  .ProjectTree .el-tree-node {
    margin: 5px 0;
  }

  .project-tree-item {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 85%;
    display: inline-block;
  }
</style>


// WEBPACK FOOTER //
// src/components/ticket/ProjectTree.vue